module.exports = __webpack_public_path__ + "static/media/movilidad.8520093a.jpg";